import React from "react";
import { ReactComponent as TickSVG } from "go-core/images/svg/subscriptionRestriction/tick.svg";
import { SubscriptionEstimationFeatureApi, SubscriptionEstimationFeatureTranslation } from "../../../api/types";

interface Props {
	bold?: boolean;
	feature: SubscriptionEstimationFeatureApi;
	translation?: SubscriptionEstimationFeatureTranslation;
}

const SubscriptionBasedRestrictionModalPlanFeature = ({ bold, feature, translation }: Props) => {
	return (
		<div className="d-flex align-items-center plan-feature">
			<TickSVG className="me-2" />
			<p className={`mb-0 ${bold ? "font-weight-bold" : ""}`}>{translation?.name ?? feature.id}</p>
		</div>
	);
};

export default SubscriptionBasedRestrictionModalPlanFeature;
